import type { ContentPack } from '../engine/pack';

/** theme@1.0.0 — tools/author-pack.ts 가 생성했다. 손으로 고치면 packHash 가 바뀐다(patch bump). */
export const PACK_THEME_1_0_0: ContentPack = {
  id: 'theme',
  version: '1.0.0',
  kind: 'inference',
  questions: [
    {
      id: 'c001',
      q: '어느 나라일까?',
      a: '인도',
      d: ['진', '노', '익', '독', '은', '더'],
      tags: ['country'],
      hints: ['카레와 요가', '타지마할', '인구 세계 1위'],
    },
    {
      id: 'c002',
      q: '어느 나라일까?',
      a: '호주',
      d: ['포', '우', '혹', '죽', '허', '조'],
      tags: ['country'],
      hints: ['캥거루', '코알라', '남반구 대륙'],
    },
    {
      id: 'c003',
      q: '어느 나라일까?',
      a: '브라질',
      d: ['므', '마', '일', '비', '락', '진'],
      tags: ['country'],
      hints: ['삼바 카니발', '아마존', '축구 왕국'],
    },
    {
      id: 'c004',
      q: '어느 나라일까?',
      a: '이집트',
      d: ['지', '입', '크', '익', '짐', '특'],
      tags: ['country'],
      hints: ['피라미드', '나일강', '파라오'],
    },
    {
      id: 'c005',
      q: '어느 나라일까?',
      a: '스페인',
      d: ['테', '펙', '브', '진', '슥', '익'],
      tags: ['country'],
      hints: ['투우와 플라멩코', '가우디', '시에스타'],
    },
    {
      id: 'c006',
      q: '어느 나라일까?',
      a: '베트남',
      d: ['메', '벡', '크', '담', '특', '납'],
      tags: ['country'],
      hints: ['아오자이', '하롱베이', '호치민'],
    },
    {
      id: 'c007',
      q: '어느 나라일까?',
      a: '이탈리아',
      d: ['지', '칼', '미', '자', '익', '탄'],
      tags: ['country'],
      hints: ['장화 모양 반도', '콜로세움', '젤라토'],
    },
    {
      id: 'c008',
      q: '어느 나라일까?',
      a: '포르투갈',
      d: ['토', '므', '쿠', '날', '폭', '륵'],
      tags: ['country'],
      hints: ['대항해 시대', '에그타르트', '호날두'],
    },
    {
      id: 'c009',
      q: '어느 도시일까?',
      a: '파리',
      d: ['타', '미', '팍', '릭', '퍼', '르'],
      tags: ['city'],
      hints: ['에펠탑', '루브르', '센강'],
    },
    {
      id: 'c010',
      q: '어느 도시일까?',
      a: '런던',
      d: ['먼', '넌', '럭', '덕', '란', '단'],
      tags: ['city'],
      hints: ['빅벤', '빨간 이층버스', '템스강'],
    },
    {
      id: 'c011',
      q: '어느 도시일까?',
      a: '시드니',
      d: ['비', '느', '디', '식', '득', '닉'],
      tags: ['city'],
      hints: ['오페라하우스', '하버 브리지', '본다이 비치'],
    },
    {
      id: 'c012',
      q: '어느 도시일까?',
      a: '베를린',
      d: ['메', '벡', '른', '민', '릴', '릭'],
      tags: ['city'],
      hints: ['무너진 장벽', '브란덴부르크 문', '커리부어스트'],
    },
    {
      id: 'c013',
      q: '어느 도시일까?',
      a: '프라하',
      d: ['트', '마', '파', '피', '락', '학'],
      tags: ['city'],
      hints: ['카를교', '천문시계', '보헤미아 맥주'],
    },
    {
      id: 'c014',
      q: '어느 도시일까?',
      a: '두바이',
      d: ['누', '마', '지', '둑', '박', '익'],
      tags: ['city'],
      hints: ['부르즈 할리파', '사막 위 마천루', '인공섬'],
    },
    {
      id: 'c015',
      q: '어느 도시일까?',
      a: '모스크바',
      d: ['로', '브', '츠', '마', '목', '슥'],
      tags: ['city'],
      hints: ['붉은 광장', '크렘린', '마트료시카'],
    },
    {
      id: 'c016',
      q: '어느 도시일까?',
      a: '이스탄불',
      d: ['지', '브', '칸', '물', '익', '슥'],
      tags: ['city'],
      hints: ['보스포루스', '블루 모스크', '유럽과 아시아'],
    },
    {
      id: 'c017',
      q: '무슨 음식일까?',
      a: '초밥',
      d: ['코', '맙', '촉', '밤', '처', '법'],
      tags: ['food'],
      hints: ['와사비와 간장', '오마카세', '참치 뱃살'],
    },
    {
      id: 'c018',
      q: '무슨 음식일까?',
      a: '타코',
      d: ['카', '초', '탁', '콕', '터', '커'],
      tags: ['food'],
      hints: ['또띠아', '살사 소스', '멕시코 길거리'],
    },
    {
      id: 'c019',
      q: '무슨 음식일까?',
      a: '파에야',
      d: ['제', '엑', '타', '약', '팍', '아'],
      tags: ['food'],
      hints: ['샤프란 쌀', '발렌시아', '커다란 팬'],
    },
    {
      id: 'c020',
      q: '무슨 음식일까?',
      a: '라자냐',
      d: ['마', '아', '냑', '락', '작', '나'],
      tags: ['food'],
      hints: ['층층이 쌓은 면', '라구 소스', '가필드'],
    },
    {
      id: 'c021',
      q: '무슨 음식일까?',
      a: '쌀국수',
      d: ['살', '싼', '눅', '부', '구', '숙'],
      tags: ['food'],
      hints: ['숙주와 고수', '맑은 소고기 국물', '하노이'],
    },
    {
      id: 'c022',
      q: '무슨 음식일까?',
      a: '비빔밥',
      d: ['미', '밈', '맙', '빅', '빕', '밤'],
      tags: ['food'],
      hints: ['고추장에 비벼', '전주', '돌솥'],
    },
    {
      id: 'c023',
      q: '무슨 음식일까?',
      a: '티라미수',
      d: ['키', '마', '리', '부', '틱', '락'],
      tags: ['food'],
      hints: ['마스카포네', '커피 적신 빵', '나를 끌어올려'],
    },
    {
      id: 'c024',
      q: '무슨 음식일까?',
      a: '크루아상',
      d: ['츠', '무', '자', '방', '큭', '룩'],
      tags: ['food'],
      hints: ['초승달 모양 빵', '버터 결', '프랑스 아침'],
    },
  ],
};
